var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row justify-between"},[_c('div',{staticClass:"row items-center"},[_c('div',[_c('q-btn',{attrs:{"color":"accent","flat":""},on:{"click":_vm.backFromOptionForm}},[_c('q-icon',{attrs:{"name":"mdi-arrow-left"}})],1)],1),_c('div',{staticClass:"title q-my-none q-mx-none"},[_vm._v("Options")])]),_c('div',{staticClass:"row justify-end"},[_c('q-btn',{staticClass:"float-right",attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveOption(null)}}},[_c('q-icon',{attrs:{"name":"mdi-plus-circle"}}),_c('span',{staticClass:"sustainability-font q-mx-sm",staticStyle:{"font-size":"13px"}},[_vm._v(" Save ")])],1)],1)]),_c('q-form',{ref:"form"},[_c('div',{staticClass:"row q-col-gutter-md"},[_c('div',{staticClass:"col-4"},[_c('q-input',{attrs:{"label":"Answer title","rules":[(v) => !!v || 'Field is Required']},model:{value:(_vm.formData.text),callback:function ($$v) {_vm.$set(_vm.formData, "text", $$v)},expression:"formData.text"}})],1),_c('div',{staticClass:"col-4"},[_c('q-input',{attrs:{"label":"Rank","rules":[
            (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
          ]},model:{value:(_vm.formData.idx),callback:function ($$v) {_vm.$set(_vm.formData, "idx", $$v)},expression:"formData.idx"}})],1),_c('div',{staticClass:"col-4"},[_c('q-select',{attrs:{"label":"Type","options":_vm.typeList,"rules":[(v) => !!v || 'Field is Required']},on:{"input":_vm.clearValues},model:{value:(_vm.formData.type),callback:function ($$v) {_vm.$set(_vm.formData, "type", $$v)},expression:"formData.type"}})],1),_c('div',{staticClass:"col-12"},[(_vm.formData.type == 'Source')?_c('q-select',{attrs:{"multiple":"","options":_vm.sourcesList,"map-options":"","option-label":"sourceName","emit-value":"","use-chips":"","label":"Select Sources"},model:{value:(_vm.formData.values),callback:function ($$v) {_vm.$set(_vm.formData, "values", $$v)},expression:"formData.values"}}):_c('q-select',{attrs:{"multiple":"","options":_vm.categoriesList,"map-options":"","option-label":"name","emit-value":"","use-chips":"","label":"Select Category"},model:{value:(_vm.formData.values),callback:function ($$v) {_vm.$set(_vm.formData, "values", $$v)},expression:"formData.values"}})],1),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"text-bold"},[_vm._v("Whats That - Side Panel")]),_c('q-editor',{staticStyle:{"height":"300px"},attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
            [
              {
                label: _vm.$q.lang.editor.align,
                icon: _vm.$q.iconSet.editor.align,
                fixedLabel: true,
                list: 'only-icons',
                options: ['left', 'center', 'right', 'justify'],
              },
              {
                label: _vm.$q.lang.editor.align,
                icon: _vm.$q.iconSet.editor.align,
                fixedLabel: true,
                options: ['left', 'center', 'right', 'justify'],
              },
            ],
            [
              'bold',
              'italic',
              'strike',
              'underline',
              'subscript',
              'superscript',
            ],
            ['token', 'hr', 'link', 'custom_btn'],
            ['print', 'fullscreen'],
            [
              {
                label: _vm.$q.lang.editor.formatting,
                icon: _vm.$q.iconSet.editor.formatting,
                list: 'no-icons',
                options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code'],
              },
              {
                label: _vm.$q.lang.editor.fontSize,
                icon: _vm.$q.iconSet.editor.fontSize,
                fixedLabel: true,
                fixedIcon: true,
                list: 'no-icons',
                options: [
                  'size-1',
                  'size-2',
                  'size-3',
                  'size-4',
                  'size-5',
                  'size-6',
                  'size-7',
                ],
              },
              {
                label: _vm.$q.lang.editor.defaultFont,
                icon: _vm.$q.iconSet.editor.font,
                fixedIcon: true,
                list: 'no-icons',
                options: [
                  'default_font',
                  'arial',
                  'arial_black',
                  'comic_sans',
                  'courier_new',
                  'impact',
                  'lucida_grande',
                  'times_new_roman',
                  'verdana',
                ],
              },
              'removeFormat',
            ],
            ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

            ['undo', 'redo'],
            ['viewsource'],
          ],"fonts":{
            arial: 'Arial',
            arial_black: 'Arial Black',
            comic_sans: 'Comic Sans MS',
            courier_new: 'Courier New',
            impact: 'Impact',
            lucida_grande: 'Lucida Grande',
            times_new_roman: 'Times New Roman',
            verdana: 'Verdana',
          }},model:{value:(_vm.formData.whatsThat),callback:function ($$v) {_vm.$set(_vm.formData, "whatsThat", $$v)},expression:"formData.whatsThat"}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }